import { createAction, props } from '@ngrx/store';
import { FilterItem } from '@fc-vehicles/components/shared/vehicle-filter/vehicles-filter.component';

import { SortBy } from '@fc-shared/ui/sort-by/sort-by';

export const setSearchLocationText = createAction(
  '[LocationFilters] Set Search Location Text',
  props<{ searchText: string }>(),
);

export const setLocationSortBy = createAction(
  '[LocationFilters] Set Sort By Location',
  props<{ sortBy: SortBy }>(),
);
export const setLocationFilter = createAction(
  '[LocationFilters] Set Locations Filter',
  props<{ filterItem: FilterItem }>(),
);

export const setManyLocationFilters = createAction(
  '[LocationFilters] Set Many Location Filters',
  props<{ filters: FilterItem[] }>(),
);

export const resetDefaultLocationFilters = createAction(
  '[LocationFilters] Reset Default Location Filters',
);
